import { html, LitElement, PropertyValues } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { closeAds } from '../utils/login-modal-setup';

@customElement('welcome-modal')
export class WelcomeModal extends LitElement {
    createRenderRoot() {
        return this;
    }

    @state()
    isOpen = true;

    tools = [
        {
            name: 'Reescrever Texto',
            href: '/reescrever-texto/',
            icon: 'icon-rewrite-color',
        },
        {
            name: 'Resumir Texto',
            href: '/resumir-texto/',
            icon: 'icon-summarize-color',
        },
        {
            name: 'Corrigir Texto',
            href: '/corretor-de-texto/',
            icon: 'icon-correct-color',
        },
        {
            name: 'Detector de IA',
            href: '/detector-de-ia/',
            icon: 'icon-detect-ia-color',
        },
    ];

    protected firstUpdated(_changedProperties: PropertyValues): void {
        closeAds();
        document.body.classList.add('no-scroll');
    }

    closeModal() {
        this.isOpen = false;
        document.body.classList.remove('no-scroll');
        this.remove();
    }
    closeModalOnCurtain(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (target?.id === 'welcome-modal') {
            this.closeModal();
        }
    }

    protected render() {
        return html`
            <div
                @click=${this.closeModalOnCurtain}
                id="welcome-modal"
                class="welcome-modal-wrapper"
                style=${this.isOpen ? 'display: block' : 'display: none'}
            >
                <div class="welcome-modal-content">
                    <span class="icon-close" @click=${this.closeModal}></span>
                    <div class="welcome-modal-content__title">Bem-vindo ao Sinônimos!</div>
                    <div class="welcome-modal-content__description">
                        Sua conta foi criada com sucesso.<br /><b
                            >Comece a melhorar seus textos agora:</b
                        >
                    </div>
                    <div class="welcome-modal-content__tools__list">
                        ${this.tools.map(
                            (tool) => html`
                                <a
                                    href="${tool.href}"
                                    class="welcome-modal-content__tools__list__item"
                                >
                                    <div class="welcome-modal-content__tools__list__item__wrapper">
                                        <span class="icon ${tool.icon}"></span>
                                        ${tool.name}
                                        <span class="icon-chevron-1"></span>
                                    </div>
                                </a>
                            `
                        )}
                    </div>
                </div>
            </div>
        `;
    }
}
